
import { Options, Vue } from 'vue-class-component'
import { PropSync, Emit } from 'vue-property-decorator'
import rfidDevicesConfig from './config/rfidDevices.json'
import { IScannerSettings } from '@/store/bizBrowser/interface'
import { UPDATE_BIZ_BROWSER_STATE } from '@/store/actions'
import { LOCAL_STORAGE_ITEM } from '@/utils/constants'

@Options({
  components: {},
  emits: ['update:isShow', 'confirm'],
  name: 'RfidDeviceSelector',
})
export default class RfidDeviceSelector extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean

  devices: Record<string, IScannerSettings> = rfidDevicesConfig
  selectedDeviceKey = ''

  mounted() {
    // Set initial selection to current device in store
    const currentDeviceKey = this.$store.getters.bizBrowserState.selectedDeviceKey
    if (currentDeviceKey) {
      this.selectedDeviceKey = currentDeviceKey
    }
  }

  get sortedDeviceKeys(): string[] {
    const deviceKeys = Object.keys(this.devices)
    const history = this.getDeviceHistory()

    const sortedKeys = [...deviceKeys].sort((a, b) => {
      const indexA = history.indexOf(a)
      const indexB = history.indexOf(b)
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB
      }
      if (indexA !== -1) {
        return -1
      }
      if (indexB !== -1) {
        return 1
      }
      return 0
    })

    return sortedKeys
  }

  getDeviceHistory(): string[] {
    try {
      const history = localStorage.getItem(LOCAL_STORAGE_ITEM.RFID_DEVICE_HISTORY)
      return history ? JSON.parse(history) : []
    } catch (error) {
      console.error('Failed to load device history:', error)
      return []
    }
  }

  saveDeviceHistory(deviceKey: string) {
    try {
      const history = this.getDeviceHistory()

      const filteredHistory = history.filter((key) => key !== deviceKey)

      const newHistory = [deviceKey, ...filteredHistory]

      localStorage.setItem(LOCAL_STORAGE_ITEM.RFID_DEVICE_HISTORY, JSON.stringify(newHistory))
    } catch (error) {
      console.error('Failed to save device history:', error)
    }
  }

  selectDevice(key: string) {
    this.selectedDeviceKey = key
  }

  @Emit('confirm')
  emitConfirm() {
    return {
      key: this.selectedDeviceKey,
      device: this.devices[this.selectedDeviceKey],
    }
  }

  onConfirm() {
    this.saveDeviceHistory(this.selectedDeviceKey)

    this.$store.dispatch(UPDATE_BIZ_BROWSER_STATE, {
      selectedDeviceKey: this.selectedDeviceKey,
      scannerSettings: this.devices[this.selectedDeviceKey],
    })

    this.emitConfirm()
    this._isShow = false
  }
}
